import {toPaymentContract} from './mappers/toPaymentContract'
import type {CreatePaymentContractService} from './types'

export const createPaymentContractService: CreatePaymentContractService = function createPaymentContractService(
  {fetchPaymentMethodsList},
  {fetchPaymentMethodActualState},
) {
  return {
    async fetchPaymentContractDetails() {
      const [paymentMethods, actualState] = await Promise.all([
        fetchPaymentMethodsList({mode: 'employee'}),
        fetchPaymentMethodActualState(),
      ])

      return toPaymentContract(paymentMethods, actualState)
    },
  }
}
